import gql from 'graphql-tag';
import type { ExperienceVersion } from '@models/experience/experience';
import apolloClient from '@/graphql/apollo-client';

export interface ExperienceNonABTestFragment {
    id: string;
    name: string;
    status: string;
    engageType: string;
    screenshot: string;
    updateTime: number | string;
    version: ExperienceVersion;
}

const LIST_QUERY = gql`
    query getEngageV4ListWithoutABTest {
        getEngageV4ListWithoutABTest {
            id
            name
            status
            enableABTest
            engageType
            screenshot
            updateTime
            versions {
                id
                name
                screenshot
            }
        }
    }
`;

export default async function useExperienceNonABTestList(): Promise<ExperienceNonABTestFragment[]> {
    const { data } = await apolloClient.query({
        fetchPolicy: 'no-cache',
        query: LIST_QUERY,
        variables: {}
    });
    return data.getEngageV4ListWithoutABTest as ExperienceNonABTestFragment[];
}
